import { dest, series, src } from 'gulp';
import eslint from 'gulp-eslint-new';
import ts from 'gulp-typescript';
import { Utilities } from './utilities';

export module LintModule {
    export function lintApp() {
        const argv = Utilities.gulpArgv();
        return src(['src/**/*.ts', '!src/generated/**/*.*'])
            .pipe(eslint({
                overrideConfigFile: `./.eslintrc.json`,
                fix: argv['fix'] as boolean
            }))
            .pipe(eslint.format())
            .pipe(dest('src'))
            .pipe(eslint.failAfterError());
    }

    export function lintUiTestAutomation() {
        const tsProject = ts.createProject('uta/tsconfig.json');

        return tsProject.src()
            .pipe(eslint())
            .pipe(eslint.format())
            .pipe(eslint.failAfterError());
    }

    export function lintUiTestAutomation_legacy() {
        return src(['ui-test-automation/**/*.ts', '!ui-test-automation/node_modules/**/*.*'])
            .pipe(eslint())
            .pipe(eslint.format())
            .pipe(eslint.failAfterError());
    }

    // for the backward compatibility with repositories that have not been onboarded to the latest ui automation framework.
    export const lint = series(lintApp, lintUiTestAutomation_legacy);
}
